import { render } from "./ExamPreview.vue?vue&type=template&id=ef6b771a&ts=true"
import script from "./ExamPreview.vue?vue&type=script&lang=ts"
export * from "./ExamPreview.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__